<template>
  <section>
    <section class="badge box-badge" :id="'badge-' + badge.id" :class="{ child: child, 'has-child': hasChild }">
      <div class="section-title no-margin">
        <div class="badge-title">
          <h3>{{ badge.name[lang] }}</h3>
        </div>
        <div class="actions">
          <k-dropdown><template slot="handler">
            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
          </template>
            <k-dropdown-option v-if="badge.status === 'testing'" @click.native="updateStatus('published')">Publish</k-dropdown-option>
            <k-dropdown-option v-if="badge.status === 'published'" @click.native="updateStatus('testing')">Testing</k-dropdown-option>
            <k-dropdown-option v-if="badge.status === 'testing'" @click.native="updateStatus('reset')">Reset</k-dropdown-option>
            <k-dropdown-option @click.native="toggleEditBadge">Edit</k-dropdown-option>
            <k-dropdown-option @click.native="confirmDeleteBadge">Delete</k-dropdown-option>
          </k-dropdown>
        </div>
        <div class="tags"><span class="tag">{{ $t('badge.state.' + badge.status) }}</span><span class="tag button" v-if="hasChild()" @click="visible.childs = !visible.childs">{{ textToggleBadges }}</span><span class="tag button" v-if="!hasChild() &amp;&amp; isUnlockable()" @click="toogleModalLinkEvent">link event</span><span class="tag button" v-else-if="!isChild()" @click="toggleCreateChildBadge">{{ $t('badge.actions.add') }}</span><span class="tag button" v-if="!copiedBadge" @click="copyBadgeToStore">copy badge</span><span class="tag button" v-else-if="!hasEvent() &amp;&amp; canPasteBadge" @click="pasteCopiedBadge">paste badge</span></div>
      </div>
      <div class="content">
        <div class="thumbnail"><img class="image" v-bind:src="img_url" /></div>
        <div class="description">
          <font-awesome-icon icon="align-left"></font-awesome-icon><span>{{ badge.description[lang] }}</span>
        </div>
        <div class="success">
          <font-awesome-icon icon="align-justify"></font-awesome-icon><span>{{ badge.successmessage[lang] }}</span>
        </div>
        <p class="resume"><span v-if="badge.activationdate &amp;&amp; badge.deactivationdate">
          <font-awesome-icon icon="calendar"></font-awesome-icon><span>{{ badge.activationdate | date }} - {{ badge.deactivationdate | date }}</span>
        </span><span>
          <font-awesome-icon icon="star"></font-awesome-icon><span>{{ badge.score }} pts</span>
        </span><span>
          <font-awesome-icon icon="users"></font-awesome-icon><span>{{ badge.donecount }}</span>
        </span><span v-if="badge.maxachieved !== -1">
          <font-awesome-icon icon="lock"></font-awesome-icon><span>{{ badge.maxachieved }}</span>
        </span></p>
        <footer v-if="isUnlockable()">
          <span class="tag unlock">{{ $t('badge.state.unlockable') }}</span>
        </footer>
        <span class="footer-resume" v-if="isUnlockable() &amp;&amp; isParent() &amp;&amp; hasChild()">
          <span>{{ $t('badge.actions.badge-unblockable-children') }}</span>
        </span>
        <span class="footer-resume" v-else-if="isUnlockable()">{{ $t('badge.actions.badge-unblockable') }}
          <el-tag style="margin:4px;" v-for="(event, index) in badge.events" v-bind:key="event.id" size="mini" type="info" closable="closable" @close="detachEvent(event, index)">{{ event.alias }}</el-tag>
          <el-tag size="mini" type="info">
            <span>{{ badge.tresholdvalue }} fois&nbsp;</span>
            <span v-if="badge.frequency != 'none'">{{ 'frequency.' + badge.frequency }}&nbsp;</span>
            <span v-if="badge.timeframe != 'none'">{{ 'timeframe.' + badge.timeframe }}</span>
            <label class="edit-event" style="margin:0 4px;" @click="toogleModalTrigger()">
              <font-awesome-icon icon="edit"></font-awesome-icon>
            </label>
          </el-tag>
        </span>
        <footer v-if="!isUnlockable()">
          <span class="tag unlock lock">{{ $t('badge.state.lockable') }}</span>
        </footer>
        <span class="footer-resume" v-if="!isUnlockable() &amp;&amp; hasChild()">
          <span>{{ $t('badge.actions.check-child-badge') }}</span>
        </span>
        <span class="footer-resume" v-if="!isUnlockable() &amp;&amp; !hasChild()">
          <span>{{ $t('badge.actions.check-infos') }} &nbsp;</span>
          <a v-if="!isChild()" @click="toggleCreateChildBadge()">{{ $t('badge.actions.add-child') }}</a>
          <span v-if="!isChild()">&nbsp; ou &nbsp;</span>
          <a @click="toogleModalLinkEvent()">{{ $t('badge.actions.link-event') }}</a>
        </span>
      </div>
      <form-badge v-if="modal.createChild" :idParent="badge.id" :idCampaign="badge.category.id" @close="toggleCreateChildBadge"></form-badge>
      <form-badge v-if="modal.update" :id="badge.id" @close="toggleEditBadge"></form-badge>
      <crud-trigger v-show="modal.trigger" :open="modal.trigger" :badge="badge" @update="updateTrigger" @close="toogleModalTrigger"></crud-trigger>
      <link-event v-if="modal.linkevent" :open="modal.linkevent" :badge="badge" @close="toogleModalLinkEvent"></link-event>
    </section>
    <div class="badge-list-child" v-if="childs.length &gt; 0" v-show="visible.childs">
      <draggable :options="{group:'badge', disabled: isOneOpen}" v-model="childs" :move="startMoving">
        <badge v-for="child in childs" :key="child.id" :badge="child" :child="true"></badge>
      </draggable>
    </div>
    <el-dialog title="Warning" :visible.sync="centerDialogVisible" width="30%" center="center"><span>Etes vous certain de vouloir détacher cette action du badge ?</span><span class="dialog-footer" slot="footer">
      <el-button @click="centerDialogVisible = false">Cancel</el-button>
      <el-button type="primary" @click="confirmUnlinkEvent">Confirm</el-button>
    </span></el-dialog>
  </section>
</template>

<script>
import FormBadge from './FormBadge.vue'
import CrudTrigger from './CrudTrigger.vue'
import LinkEvent from './LinkEvent.vue'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'badge',
  props: ['badge', 'index', 'child'],

  components: { CrudTrigger, LinkEvent, FormBadge, draggable },

  data () {
    return {
      eventToUnlink: null,
      centerDialogVisible: false,
      openMoreAction: false,
      modal: {
        createChild: false,
        update: false,
        linkevent: false,
        trigger: false
      },
      visible: {
        childs: false
      },
      currentBadge: this.badge
    }
  },
  computed: {
    textToggleBadges () {
      return !this.visible.childs ? this.$t('badge.actions.see') : this.$t('badge.actions.hide')
    },
    img_url () {
      return this.badge.media.url
    },
    status () {
      switch (this.badge.status) {
      case 'testing':
        return 'En Test'
      case 'published':
        return 'Publié'
      case 'terminated':
        return 'Terminé'
      }
    },
    canPasteBadge () {
      if (this.copiedBadge && this.copiedBadge.children.length === 0 && !this.isChild()) {
        return true
      } else {
        return false
      }
    },

    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('badges', {
      getById: 'getById',
      badgeMoving: 'badgeMoving',
      copiedBadge: 'copiedBadge'
    }),
    ...mapGetters('modals', ['isOneOpen']),
    childs: {
      get () {
        return this.badge.children.slice().sort(function (a, b) {
          return a.order - b.order
        })
      },
      set (badges) {
        let moving = this._.cloneDeep(this.badgeMoving, false)
        let order = 1
        badges.forEach((badge) => {
          if (moving.id === badge.id) {
            let bdg = {
              id: badge.id,
              order: order,
              parent: {id: this.badge.id}
            }
            this.moveBadge({badge: bdg})
          }
          order++
        })
      }
    }
  },
  watch: {
    'badge.status': function (oldValue, newValue) {
    }
  },
  methods: {
    ...mapActions('modals', ['toggle']),
    ...mapActions('badges', ['startMove', 'unLinkEvent', 'updateBadge', 'moveBadge', 'removeBadge', 'copyBadge', 'pasteBadge']),

    copyBadgeToStore () {
      const fakeBadge = (({
        activationdate,
        deactivationdate,
        description,
        events,
        hidden,
        link,
        maxachieved,
        media,
        name,
        score,
        secret,
        successmessage
      }) => ({
        activationdate,
        deactivationdate,
        description,
        events,
        hidden,
        link,
        maxachieved,
        media,
        name,
        score,
        secret,
        successmessage
      }))(this.badge)

      if (this.badge.children) {
        const children = this.badge.children.map(child => {
          return (({
            activationdate,
            deactivationdate,
            description,
            events,
            hidden,
            link,
            maxachieved,
            media,
            name,
            score,
            secret,
            successmessage
          }) => ({
            activationdate,
            deactivationdate,
            description,
            events,
            hidden,
            link,
            maxachieved,
            media,
            name,
            score,
            secret,
            successmessage
          }))(child)
        })
        fakeBadge.children = children
      }
      this.copyBadge(fakeBadge)
    },

    pasteCopiedBadge () {
      const badge = this.copiedBadge
      if (this.badge.parent) {
        badge.parent = {}
        badge.parent.id = this.badge.id
      }
      badge.category = {}
      badge.category.id = this.badge.category.id
      this.pasteBadge(badge)
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.pasted')})
        })
        .catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },

    unlinkChild () {
      let badge = Object.assign({}, this.badge)

      badge.parent = {}
      this.updateBadge({badge: badge, sitekey: this.site.sitekey})
        .then(() => {
          this.badge.parent = {}
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.edited')})
        })
        .catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },
    toggleChild () {
      this.visible.childs = !this.visible.childs
    },
    toggleCreateChildBadge (badge) {
      this.modal.createChild = !this.modal.createChild

      if (badge) {
        this.visible.childs = true

        setTimeout(() => {
          let element = document.getElementById('badge-' + badge.id)
          if (element) {
            this.$SmoothScroll(element, 800)
          }
        }, 200)
      }
    },
    toggleEditBadge () {
      this.closeDropdown()

      this.modal.update = !this.modal.update
    },
    toogleModalTrigger () {
      this.closeDropdown()

      this.modal.trigger = !this.modal.trigger
    },
    toogleModalLinkEvent () {
      this.modal.linkevent = !this.modal.linkevent
    },

    hasEvent () {
      if (this.badge.events.length > 0) {
        return true
      }
      return false
    },
    hasChild () {
      if (this.badge.children.length > 0) {
        return true
      }
      return false
    },
    isChild () {
      if (this.badge.parent && this.badge.parent.id) {
        return true
      }
      return false
    },
    isParent () {
      return !this.isChild()
    },
    isUnlockable () {
      if (this.isParent() && this.hasChild()) {
        for (var i = 0; i < this.badge.children.length; i++) {
          if (this.badge.children[i].events.length === 0) {
            return false
          }
        }
        return true
      } else if (this.isParent() && this.hasEvent()) {
        return true
      } else if (this.isChild() && this.hasEvent()) {
        return true
      }
      return false
    },
    detachEvent (event) {
      this.eventToUnlink = event
      this.centerDialogVisible = true
    },
    confirmUnlinkEvent () {
      this.unLinkEvent({ badge: this.badge, event: this.eventToUnlink, sitekey: this.$route.params.site })
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.removedEvent'), type: 'success'})
        }).catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
      this.centerDialogVisible = false
    },

    updateTrigger (triggers) {
      this.closeDropdown()

      var badge = {
        id: this.badge.id,
        timeframe: triggers.timeframe,
        tresholdvalue: triggers.tresholdvalue,
        frequency: triggers.frequency
      }

      this.updateBadge({ badge: badge, sitekey: this.$route.params.site })
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.edited')})
        }).catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })

      this.toogleModalTrigger()
    },

    updateStatus (status) {
      this.closeDropdown()

      this.badge.status = status
      this.updateBadge({ badge: this.badge, sitekey: this.$route.params.site })
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.edited')})
        })
        .catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },

    /**
     * CRUD Badge
     */

    confirmDeleteBadge () {
      this.closeDropdown()

      this.removeBadge({ badge: this.badge })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.badge.deleted'),
            type: 'success'
          })
        })
        .catch((e) => {
          this.$notify.error({
            title: 'Error',
            message: this.$root.$t('notifications.unknown')
          })
        })
    },

    closeDropdown () {
      this.openMoreAction = false
    },
    startMoving (evt) {
      let badge = this.getById(evt.draggedContext.element.id)
      this.startMove(badge)
    }
  }
}
</script>

<style lang="scss" scoped>
.badge {
  margin: 6px 0;
  padding: 10px;
  font-size: 13px;
  font-weight: 500;
  position: relative;
  border-bottom:1px solid #eaefea;

  .tag {
    background: #dedede;
    color:#565656;
  }
}
.badge-actions {
  opacity: 0.4;
}
.image {
  max-width: 100%;
  max-height: 100%;
  display: block;
  border-radius: 4px;
}

.badge-list-child {
  width: 100%;
  border-bottom: 1px solid #eaefea;
  .badge-list-child {
    border:0;
  }
  .badge.child {
    width: 90%;
    margin-left:10%;
    border-bottom: 1px solid #eaefea;
  }
  div section {
    &:last-child {
      .badge.child {
        border-bottom: 0;
      }
    }
  }
}

.badge.child {
  margin:0;
  border-radius: 0;
  border-left:1px solid #eaefea;
  border-top:0;
  border-bottom: 0;
}

.box-badge {
  margin-top:0;
  margin-bottom: 0px;
  background: #fff;

  .section-title {
    display: grid;
    grid-template-columns: 1fr 40px;
    margin-bottom: 12px;
    > h3 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .group-actions {
      justify-content: end;
    }
  }
}
.group-actions-badge {
  float: right;
}
button.testing {
  color: #446CB3;
}
button.published {
  color: #3FC380;
}
button.terminated {
  color: #6C7A89;
}

div.thumbnail {
   grid-area: avatar;
   width: 100%;
   height: 100%;
   text-align: center;
   img {
     display: inline-block;
   }
}
.description {
   grid-area: description;
   svg {
        margin-right: 10px;
     }
}
.success {
   grid-area: success;
   svg {
        margin-right: 10px;
     }
}
.resume {
  font-size: 13px;
   grid-area: resume;
   > span {
     margin-right: 24px;
     > svg {
        margin-right: 4px;
     }
   }
}
.unlock {
   grid-area: unlock;
}
.footer-resume {
   grid-area: sentence;
}
div.content {
  display: grid;
  justify-items: left;
  align-items: center;
  grid-template-columns: 100px 1fr;
  grid-template-rows: 1fr/2 1fr 1fr fr;
  grid-column-gap: 12px;
  grid-row-gap: 4px;
  grid-template-areas:
    "avatar description"
    "avatar success"
    "avatar resume"
    "unlock sentence"
    ;
}

span.tag.unlock {
  width: 100%;
  padding: 4px 8px;
  color:#fff;
  background: #3FC380;
  display: inline-block;
  text-align:center;
  &.lock {
    background:#446CB3;
  }
}
footer {
  width: 100%;
}
a {
  cursor: pointer;
}

.tags {
  .tag.button {
    transition: opacity 600ms ease;
    opacity: 0.3;
    border:1px solid #aeaeae;
    color:#aeaeae;
    cursor: pointer;
    background:#fff;
  }
}
.box-badge {
  &:hover {
    .tag.button {
      opacity: 1;
    }
  }
}

.last-child {
  .box-badge {
    border-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/badges/Badge.vue